import { FC } from 'react';
import { vars } from '@croquiscom-pvt/zds/tokens';
import styled from '@emotion/styled';

import { EmptyViewError } from './EmptyViewError';

interface Props {
  isNetworkError?: boolean;
  title?: string;
  description?: string;
  retry?: () => void;
  height?: string;
}

export const ServerError: FC<React.PropsWithChildren<Props>> = ({
  isNetworkError = false,
  title,
  description,
  retry,
  height = '100vh',
}: Props) => {
  return (
    <Wrap $height={height}>
      <EmptyViewError isNetworkError={isNetworkError} title={title} description={description} retry={retry} />
    </Wrap>
  );
};

const Wrap = styled.div<{ $height: string }>`
  display: flex;
  justify-content: center;
  align-items: center;
  flex-direction: column;
  width: 100%;
  height: ${({ $height }) => $height};
  background-color: ${vars.color.backgroundSurface};
`;
